import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { className, ...props },
  ref,
) {
  return (
    <span className="relative inline-flex">
      <input
        ref={ref}
        type="radio"
        className={cn(
          "peer h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-full border border-border bg-input transition-colors",
          "checked:border-primary",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/55",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
      <span className="pointer-events-none absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary opacity-0 transition-opacity peer-checked:opacity-100" />
    </span>
  );
});
